/**
 * Base Model
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var Backbone = require('backbone');

    /**
     * @class
     * @name BaseModel
     * @augments Backbone.Model
     */
    module.exports = Backbone.Model.extend(/** @lends BaseModel.prototype */ {

        constructor: function() {
            Backbone.Model.apply(this, arguments);
            this.subscribe.apply(this, arguments);
        },

        /**
         * Init all listeners in subscribe method for better inheritance
         */
        subscribe: _.noop,

        fetch: function() {
            this.trigger('fetch', this);
            return Backbone.Model.prototype.fetch.apply(this, arguments);
        },

        /**
         * Reset model to defaults with or without cached attributes
         * @param {boolean} [shouldUseCachedAttributes]
         * @param {Object} [options]
         * @param {Array|string} [additionalPreservedAttributes]
         * @return {BaseModel}
         */
        reset: function(shouldUseCachedAttributes, options, additionalPreservedAttributes) {
            var unsetDifferentAttributes = function(preservedAttrs) {
                var finalAttrs = additionalPreservedAttributes != null
                    ? _.union(preservedAttrs, additionalPreservedAttributes)
                    : preservedAttrs;
                var resetKeys = _.difference(_.keys(this.attributes), finalAttrs).reduce(function(memo, key) {
                    memo[key] = undefined;
                    return memo;
                }, {});
                this.set(resetKeys, _.extend({}, options, { unset: true }));
            }.bind(this);
            var defaults = _.extend({}, _.result(this, 'defaults'));

            if (shouldUseCachedAttributes) {
                var preservedAttrs = _.union(_.keys(defaults), this.cachedAttributes);
                unsetDifferentAttributes(preservedAttrs);
                this.set(_.extend(defaults, _.pick(this.attributes, this.cachedAttributes)), options);
            } else {
                unsetDifferentAttributes(_.keys(defaults));
                this.set(defaults, options);
            }

            return this;
        },

        toJSON: function() {
            var serializableProperties = _.keys(this.attributes).filter(function(key) {
                return !(this.attributes[key] instanceof Backbone.Model);
            }, this);

            return _.pick(this.attributes, serializableProperties);
        },

        /**
         * Close method for overriding in extended models called when we are ditching the instance
         */
        close: function() {
            this.stopListening();
        },

        destroy: function() {
            this.stopListening();
            return Backbone.Model.prototype.destroy.apply(this, arguments);
        }

    });

});
